import React from 'react';
import { ServicesLinks } from '../../data/servicesData';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

export default function ServiceTemplate({ onLinkClick }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
      {ServicesLinks.map((link, index) => (
        <Link
          key={index}
          to={link.url}
          onClick={onLinkClick}
          className="group flex items-start gap-4 rounded-xl p-3
                     transition-all duration-300 hover:bg-[var(--accent-soft)]"
        >
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl
                          bg-[var(--accent-soft)] text-accent transition-all duration-300
                          group-hover:bg-accent group-hover:text-white">
            <link.icon className="text-lg" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <p className="text-sm font-semibold text-gray-800 dark:text-white group-hover:text-accent transition-colors duration-300">
                {link.title}
              </p>
              <FaArrowRight className="text-[10px] text-gray-300 opacity-0 -translate-x-1
                                       group-hover:opacity-100 group-hover:translate-x-0
                                       transition-all duration-300" />
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 leading-relaxed">{link.description}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}
